<template>
  <section class="informationModel">
    <h2 class="informationModel__title">Informacion modelo</h2>
    <div class="informationModel__contentInput">
      <label for="artisticName"> {{ nameLabel }}<span> *</span> </label>
      <input
        class="informationModel__input"
        type="text"
        id="artisticName"
        ref="artisticNameForm"
        :placeholder="nameLabel"
        v-model="$store.state.user.dataUser.artisticName"
        @blur="validateString('artisticName', 'artisticNameForm', nameLabel)" />
    </div>
    <span ref="artisticName" class="informationModel__error"></span>
    <div class="informationModel__contentInput" v-if="canSeeQualification">
      <label for="artisticName"> {{ qualificationLabel }}<span v-if="!isGroupAccount"> *</span> </label>
      <div class="informationModel-starts">
        <span class="informationModel-start selectedStar" v-for="star in valuesStars" :value="star" :key="star" @click="selectStar(star)" @mouseout="outMouse(star)" @mouseover="entryMouse(star)">
          ★
        </span>
      </div>
    </div>
    <span v-if="canSeeQualification" ref="qualification" class="informationModel__error"></span>
    <div class="informationModel__contentInput">
      <label for="entrydate"> Fecha de ingreso<span v-if="isGroupAccount"> *</span> </label>
      <input class="informationModel__input" type="date" id="entrydate" v-model="$store.state.user.dataUser.entrydate" />
    </div>
    <div class="informationModel__contentInput">
      <label for="monitorId">Monitor</label>
      <select class="informationModel__input" id="monitorId" v-model="$store.state.user.dataUser.monitorId">
        <option v-for="monitor in monitorOptions" :value="monitor.value" :key="monitor.value">{{ monitor.text }}</option>
      </select>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from "vuex";
  import { formatString } from "@/js/validation.js";
  export default {
    data() {
      return {
        valuesStars: ["1", "2", "3", "4", "5"],
      };
    },
    computed: {
      ...mapGetters("users", ["getMonitors"]),
      monitorOptions() {
        const monitors = this.getMonitors || [];
        const userPT = Array.isArray(this.user?.platformType) ? this.user.platformType : [];

        const filtered = monitors
          .filter((m) => {
            if (!m.isEnable) return false;

            const monitorPT = Array.isArray(m.platformType) ? m.platformType : [];

            if (userPT.length === 0) return true;

            const match = userPT.some((t) => monitorPT.includes(t));

            return match;
          })
          .map((m) => ({ value: m._id, text: m.user }));

        return filtered;
      },
      user() {
        return this.$store.state.user.dataUser;
      },
      isEditUser() {
        return !!this.user?._id;
      },
      isGroupAccount() {
        const accountType = this.user?.accountType;
        if (accountType === "group") return true;

        const value = this.user.platformType;
        const list = Array.isArray(value) ? value : value ? [value] : [];
        return list.includes("group");
      },
      nameLabel() {
        return this.isGroupAccount ? "Nombre del show" : "Nombre artístico";
      },
      qualificationLabel() {
        return this.isGroupAccount ? "Calificación del show" : "Calificación";
      },
      canSeeQualification() {
        return !this.isGroupAccount && this.isSuperAdmin(this.$userData);
      },
    },
    methods: {
      selectStar(value) {
        this.$store.state.user.dataUser.qualification = value;
        this.validateQualification("qualification", value);
      },
      outMouse() {
        const starSelected = this.$store.state.user.dataUser.qualification;
        const valueToSet = starSelected > "0" ? starSelected : "0";
        this.setQualification(valueToSet);
      },
      entryMouse(value) {
        this.setQualification(value);
      },
      setQualification(value) {
        const starts = document.querySelectorAll(`.selectedStar`);
        starts.forEach((start) => {
          start.classList.remove("starActive");

          if (start.getAttribute("value") <= value) {
            start.classList.add("starActive");
          }
        });
      },
      validateString(ref, refLocal, text, data) {
        const reference = this.$refs[ref];
        const referenceLocal = this.$refs[refLocal];
        const dataToSet = data ?? event?.srcElement ?? { value: "" };

        const response = formatString(reference, text, dataToSet);

        this.updateStyles(reference, referenceLocal, response);
        return response;
      },
      validateQualification(ref, data) {
        if (!this.canSeeQualification) {
          const reference = this.$refs[ref];
          reference.innerText = "";
          this.updateStyles(reference, "", true);
          return true;
        }

        const reference = this.$refs[ref];
        const response = !!+data;

        reference.innerText = !response ? `Ingrese la calificacion` : "";

        this.updateStyles(reference, "", response);
        return response;
      },
      updateStyles(reference, referenceLocal, response) {
        if (reference?.style) reference.style.display = response ? "none" : "block";
        if (referenceLocal?.style) referenceLocal.style["border-color"] = response ? "#d8d8d8" : "#bd0909";
      },
      verifyNext() {
        if (this.isGroupAccount) return true;

        const { artisticName, qualification } = this.$store.state.user.dataUser;
        const nameForm = this.validateString("artisticName", "artisticNameForm", this.nameLabel, { value: artisticName });

        const hasQualification = this.validateQualification("qualification", qualification);

        return nameForm && hasQualification;
      },
    },
    mounted() {
      this.outMouse();

      if (this.isEditUser) {
        this.verifyNext();
      }
    },
  };
</script>

<style lang="scss">
  .informationModel {
    @include Flex(column, flex-start, flex-start);
    width: 100%;
    gap: $mpadding;
    &__title {
      font-weight: lighter;
      font-size: 24px;
    }
    &__contentInput {
      width: 100%;
    }
    &__input {
      width: 100%;
      height: 40px;
      border: 1px solid $alto;
      border-radius: 6px;
      padding: 5px;
      &:focus {
        outline: none;
      }
    }
    &-starts {
      font-size: 35px;
      color: #ccc;
      margin-top: -10px;
    }
    .starActive {
      transition: 0.3s ease-in-out;
      color: $primary-color;
    }
    &__error {
      display: none;
      margin-top: -10px;
      font-weight: 600;
      font-size: 0.8em;
      color: $primary-color;
    }
  }
</style>
